import actions from "../../constants/actions";

export const changeCookies = (value) => {
    return {
        type: actions.CHANGE_COOKIES,
        payload: {
            value,
        },
    };
};

export const changeSplash = (value) => {
    return {
        type: actions.CHANGE_SPLASH,
        payload: {
            value,
        },
    };
};

export const changeNewsletter = (value) => {
    return {
        type: actions.CHANGE_NEWSLETTER,
        payload: {
            value,
        },
    };
};

export const changeLogin = (value) => {
    return {
        type: actions.CHANGE_LOGIN,
        payload: {
            value,
        },
    };
};

export const changeFloor = (value, slug) => {
    return {
        type: actions.CHANGE_FLOOR,
        payload: {
            value,
            slug,
        },
    };
};

export const changeMobileFloor = (value, slug) => {
    return {
        type: actions.CHANGE_MOBILE_FLOOR,
        payload: {
            value,
            slug,
        },
    };
};

export const changeFaq = (value, theme = 0) => {
    return {
        type: actions.CHANGE_FAQ,
        payload: {
            value,
            theme,
        },
    };
};

export const changeMobileFaq = (value, theme = 0) => {
    return {
        type: actions.CHANGE_MOBILE_FAQ,
        payload: {
            value,
            theme,
        },
    };
};

export const changeMobileClasse = (value, lesson) => {
    return {
        type: actions.CHANGE_MOBILE_CLASSE,
        payload: {
            value,
            lesson,
        },
    };
};

export const changeDynamicBooking = (value) => {
    return {
        type: actions.CHANGE_DYNAMIC_BOOKING,
        payload: {
            value,
        },
    };
};

export const changeArtisticsBooking = (value) => {
    return {
        type: actions.CHANGE_ARTISTICS_BOOKING,
        payload: {
            value,
        },
    };
};

export const changeClaimBooking = (value) => {
    return {
        type: actions.CHANGE_CLAIM_BOOKING,
        payload: {
            value,
        },
    };
};

export const changeTechnicsBooking = (value) => {
    return {
        type: actions.CHANGE_TECHNICS_BOOKING,
        payload: {
            value,
        },
    };
};

export const changeSpacesBooking = (value) => {
    return {
        type: actions.CHANGE_SPACES_BOOKING,
        payload: {
            value,
        },
    };
};

export const changeMobileMenu = (value) => {
    return {
        type: actions.CHANGE_MOBILE_MENU,
        payload: {
            value,
        },
    };
};

export const changeSearch = (value) => {
    return {
        type: actions.CHANGE_SEARCH,
        payload: {
            value,
        },
    };
};
